import { render, staticRenderFns } from "./widget-eventsByDate.vue?vue&type=template&id=5a98e6e7"
import script from "./widget-eventsByDate.vue?vue&type=script&lang=ts"
export * from "./widget-eventsByDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports